import React, { useEffect, useRef, useState } from 'react';
import logger from 'src/utils/logger';
import PropTypes from 'prop-types';
import { useSDK } from './ScanditSDKContext';
import { Button } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

const BarcodePicker = (props) => {
  const { sdk, loaded, error: sdkError } = useSDK();
  const containerRef = useRef(null);
  const [cameraError, setCameraError] = useState(null);

  useEffect(() => {
    if (!loaded || !sdk || sdkError) return;

    let isActive = true;

    const startScanner = async () => {
      try {
        setCameraError(null);
        sdk.connectToElement(containerRef.current);

        const listener = {
          didScan: async (barcodeCapture, session) => {
            if (isActive && props.onScan) {
              props.onScan({ barcodes: session.newlyRecognizedBarcode.data });
            }
          }
        };

        sdk.addBarcodeCaptureListener(listener);
        await sdk.enableScanning(true);

      } catch (error) {
        if (!isActive) return;
        logger.error("Kamera Hatası:", error);

        if (error.name === 'NotAllowedError' || error.message?.includes('Permission denied')) {
          setCameraError('Kamera izni reddedildi. Lütfen ayarlarından izin verin.');
        } else if (error.name === 'NotReadableError' || error.message?.includes('Could not start video source')) {
          setCameraError('Kamera başka bir uygulama tarafından kullanılıyor veya erişilemiyor. Lütfen diğer uygulamaları kapatıp tekrar deneyin.');
        } else if (error.name === 'NotFoundError') {
          setCameraError('Kamera bulunamadı. Cihazınızda kamera olduğundan emin olun.');
        } else if (error.name === 'OverconstrainedError') {
          setCameraError('Kamera ayarları desteklenmiyor. Lütfen farklı bir kamera deneyin.');
        } else {
          setCameraError('Kamera başlatılamadı. Cihaz kamerasının açık olduğundan emin olun.');
        }
      }
    };

    startScanner();

    return () => {
      isActive = false;
      sdk.enableScanning(false).catch(() => { });
      sdk.detachFromElement();
    };
  }, [loaded, sdk, sdkError, props]);

  const handleRetry = async () => {
    // İzin durumunu kontrol et (Sadece destekleyen tarayıcılarda)
    if (navigator.permissions && navigator.permissions.query) {
      const status = await navigator.permissions.query({ name: 'camera' });
      if (status.state === 'denied') {
        alert("Kamera izni kalıcı olarak engellenmiş. Lütfen adres çubuğundaki 'Kilit' 🔒 simgesine tıklayıp kameraya izin verin, ardından sayfayı yenileyin.");
        return;
      }
    }
    if (window && window.location) {
      window.location.reload();
    }
  };

  if (sdkError || cameraError) {
    return (
      <div style={styles.container}>
        <div style={styles.errorOverlay}>
          <div style={styles.errorBox}>
            <h3 style={styles.errorTitle}><span role="img" aria-label="uyarı">⚠️</span> Dikkat</h3>
            <p style={styles.errorMessage}>{sdkError?.message || cameraError}</p>
            <p style={styles.helpText}>Adres çubuğundaki kilit simgesine dokunarak izinleri kontrol edebilirsiniz.</p>
            <Button
              variant="contained"
              color="secondary"
              size='small'
              endIcon={<RefreshIcon>Close</RefreshIcon>}
              onClick={handleRetry}>
              Yenİle ve Tekrar Dene
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <div ref={containerRef} style={styles.container} />;
};

const styles = {
  container: {
    width: '100%',
    height: '80vh',
    position: 'relative',
    backgroundColor: '#000',
    overflow: 'hidden',
  },
  errorOverlay: {
    position: 'absolute',
    top: 0, left: 0, width: '100%', height: '100%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
    padding: '15px',
    boxSizing: 'border-box',
    zIndex: 1000
  },
  errorBox: {
    backgroundColor: '#fff',
    padding: '25px',
    borderRadius: '15px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '320px', // Mobilde sağa kaymayı engellemek için ideal genişlik
  },
  errorTitle: { color: '#d32f2f', margin: '0 0 10px 0' },
  errorMessage: { color: '#333', fontSize: '14px', marginBottom: '10px' },
  helpText: { color: '#666', fontSize: '12px', marginBottom: '20px', fontStyle: 'italic' },
  retryButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '25px',
    fontSize: '15px',
    fontWeight: 'bold',
    width: '100%'
  }
};

BarcodePicker.propTypes = { onScan: PropTypes.func, onError: PropTypes.func };
export default BarcodePicker;